
                import "css-modules://src_components_fluidtitle_fluidtitle"
                export default {"Main":"_eb8c2c","Narrow":"_b67fa6","Title":"_4bc547","Link":"_7557d9"}
            